import Cookies from 'js-cookie'
import { create } from 'zustand'

const ACCESS_TOKEN = 'thisisjustarandomstring'
const USER_DATA = 'kullanici_bilgileri'

interface AuthUser {
  _id?: string
  adSoyad?: string
  eposta?: string
  accountNo?: string
  email?: string
  role?: string[]
  exp?: number
}

interface AuthState {
  auth: {
    user: AuthUser | null
    setUser: (user: AuthUser | null) => void
    accessToken: string
    setAccessToken: (accessToken: string) => void
    resetAccessToken: () => void
    reset: () => void
  }
}

export const useAuthStore = create<AuthState>()((set) => {
  const cookieState = Cookies.get(ACCESS_TOKEN)
  const initToken = cookieState || ''
  
  // Cookie'den user bilgisini oku
  const userCookie = Cookies.get(USER_DATA)
  const initUser: AuthUser | null = userCookie ? JSON.parse(userCookie) : null
  
  return {
    auth: {
      user: initUser,
      setUser: (user) => {
        if (user) {
          Cookies.set(USER_DATA, JSON.stringify(user), { expires: 7 })
        } else {
          Cookies.remove(USER_DATA)
        }
        set((state) => ({ ...state, auth: { ...state.auth, user } }))
      },
      accessToken: initToken,
      setAccessToken: (accessToken) => {
        Cookies.set(ACCESS_TOKEN, accessToken, { expires: 7 })
        set((state) => ({ ...state, auth: { ...state.auth, accessToken } }))
      },
      resetAccessToken: () => {
        Cookies.remove(ACCESS_TOKEN)
        set((state) => ({ ...state, auth: { ...state.auth, accessToken: '' } }))
      },
      reset: () => {
        Cookies.remove(ACCESS_TOKEN)
        Cookies.remove(USER_DATA)
        set((state) => ({
          ...state,
          auth: { ...state.auth, user: null, accessToken: '' },
        }))
      },
    },
  }
})

// export const useAuth = () => useAuthStore((state) => state.auth)
